export enum AnswerRating {
  Up = 'UP',
  Down = 'DOWN',
  /** The answer can hurt a customer or our data, so a person must look at it. */
  Flag = 'FLAG',
}

export enum FlagReason {
  WrongFact = 'WRONG_FACT',
  WrongAction = 'WRONG_ACTION',
  DataInWrongPlace = 'DATA_IN_WRONG_PLACE',
  Other = 'OTHER',
}

export interface AnswerFeedback {
  rating: AnswerRating
  /** Required for a flag, empty otherwise. */
  flagReason: FlagReason | ''
  comment: string
}
